module.exports = __webpack_public_path__ + "assets/excel327c7ded.png";